
import { Base } from '../base-component';
import './file-list-filter-category.component.scss';

import * as $ from 'jquery';

export class FileListFilterCategory extends Base {

	constructor(element: Element){

		super(element)
				
	}

	// values
	valueCategory: any;

	// selects
	selectContainer: any;
	selectCategory: any;
	selectBox: any;
	selectBoxCategory: any;
	selectBoxCategoryItem: any;


	init(){

		this.selectCategory = this.element.querySelector('.js-select-category');
		this.selectBox = this.element.querySelector('.file-list-filter-category__form__select--box');
		this.selectBoxCategory = Array.from(this.element.querySelectorAll('.file-list-filter-category__form__select--box__button'));
		this.selectBoxCategoryItem = Array.from(this.element.querySelectorAll('.file-list-filter-category__form__select--box__item'));

	}

	changeCategory(value: any) {
		console.log(value);
	}
		
	bindEvents(){

		// mobile select
		this.selectCategory.addEventListener('change', (event)=>{
			let element = event.target;			
			let parent = element.closest('.file-list-filter-category__form__select');
			let button = parent.querySelector('.file-list-filter-category__form__select--box__button');
			let text = element.options(element.selectedIndex).innerHTML;
			button.innerHTML = text;
			this.changeCategory(element.value);
		});

		// desktop button
		this.selectBoxCategory.map((item) => item.addEventListener('click', (event) => {
			if(this.selectBox.classList.contains('file-list-filter-category__form__select--box__active')){
				this.selectBox.classList.remove('file-list-filter-category__form__select--box__active');
			}else{
				this.selectBox.classList.add('file-list-filter-category__form__select--box__active');
			}
		}));

		// desktop select
		this.selectBoxCategoryItem.map((item) => item.addEventListener('click', (event) => {

			let element = event.target;
			let dataName = element.getAttribute('data-name');
			let dataValue = element.getAttribute('data-value');
			let i;
			let parent = element.closest('.file-list-filter-category__form__select');
			let select = parent.querySelector('select');
			for( i = 0; i < select.length; i++) { 
				if(select[i].value === dataValue) { 
					break; 
				} 
			}
			select.options.selectedIndex = i;
			let container = element.closest('.file-list-filter-category__form__select__desktop-container');
			let button = container.querySelector('.file-list-filter-category__form__select--box__button');
			this.selectBox.classList.remove('file-list-filter-category__form__select--box__active');
			button.innerHTML = dataName;
			this.changeCategory(select.value);

		}));
		
	}

}


// WEBPACK FOOTER //
// ./components/file-list-filter-category/file-list-filter-category.component.ts